<template>
  <base-print button="打印" @print="sbPrint">
    <div class="print screen-disnone" v-for="(page, index) in printPages">
    <!-- <div class="print" ms-repeat-elem="printArr"> -->
        <h3 class="print-title tc">{{userInfo.company_name}}&nbsp;&nbsp;&nbsp;&nbsp;三包理赔单</h3>
        <!--<h3 class="print-title tc">[#docType#]（[# printType == 1 ? "甲乙丙丁" : account.nick_name#]）</h3>-->
        <div class="list clearfix">
            <ul>
                <li class="list-item">
                    <label><b>单据日期:</b></label>
                    <span><b>{{info.work_time}}</b></span>
                </li>
                <li class="list-item">
                    <label>单号:</label>
                    <span>{{info.transaction_no_display}}</span>
                </li>
                <li class="list-item">
                    <label>印刷号:</label>
                    <span></span>
                </li>
                <li class="list-item">
                    <label>客户名称:</label>
                    <span>{{info.customer_name}}</span>
                </li>
                <li class="list-item">
                    <label>联系人:</label>
                    <span>{{info.lianxiren}}</span>
                </li>
                <li class="list-item">
                    <label>联系电话:</label>
                    <span>{{info.phone}}}</span>
                </li>
                <li class="list-item">
                    <label>送货地址:</label>
                    <span>{{info.lianxi_address}}</span>
                </li>
                <li class="list-item">
                    <label>送单人:</label>
                    <span>{{info.sender}}</span>
                </li>
                 <li class="list-item">
                    <label>页码:</label>
                    <span>第{{index + 1}}页，共{{printPages.length}}页</span>
                </li>
            </ul>
        </div>
        <div class="print-table mb10">
            <table class="c555 tabel-fixed">
                <colgroup>
                    <col width="220">
                    <col width="42">
                    <col width="50">
                    <col width="90">
                    <col width="100">
                    <col width="130">
                    <col width="100">
                    <col width="130">
                </colgroup>
                <thead>
                    <tr>
                        <th >货品名称</th>
                        <th >胎号</th>
                        <th >余花</th>
                        <th >贴损金额</th>
                        <th >理赔金额</th>
                        <th>理赔类型</th>
                        <th>病像</th>
                        <th>自编号</th>
                    </tr>
                </thead>
                <tbody id="tbody">
                    <tr v-for="product in page.products" class="trTag">
                        <td class="tl">{{product.product_name}}</td>
                        <td >{{product.dot_no}}</td>
                        <td>{{product.yuhua}} </td>
                        <td class="tr">{{product.tiesun_amount}}</td>
                        <td class="tr">{{product.lipei_amount}}</td>
                        <td>{{product.lipei_type}}</td>
                        <td>{{product.bingxiang}}</td>
                        <td class='tl'>{{product.self_number}}</td>
                    </tr>
                    <tr v-for="t in blankArr">
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr id="trTotal">
                        <td>小计</td>
                        <td></td>
                        <td></td>
                        <td class='tr'>{{page.TSXiaoji}}</td>
                        <td class="tr">{{page.LPXiaoji}}</td>
                        <td colspan="3">{{page.LPRevert}}</td>
                    
                    </tr>
                    <tr>
                        <td>合计</td>
                        <td class='tl'></td>
                        <td></td>
                        <td class="tr">{{info.tiesun_total_amount}}</td>
                        <td class="tr">{{info.lipei_total_amount}}</td>
                        <td colspan="3">{{info.lipei_total_revert}}</td>
                    </tr>
                    <tr>
                        <td colspan="8"  class="tl">摘要：{{info.zhaiyao}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="list list-b clearfix" style='line-height: 20px;'>
            <ul>
                <li class="list-item" style="width: 36.333%;">
                    <label>质检:</label>
                    <span>
       
                    </span>
                </li>
                <li class="list-item" style="width: 36.333%;">
                    <label>复核:</label>
                    <span></span>
                </li>
                <li class="list-item" style="width: 27.333%;">
                    <label>收款人:</label>
                    <span></span>
                </li>
            </ul>
        </div>
        <div class="list  clearfix" style='line-height: 20px;'>
            <ul>
                <li class="list-item" style="width: 36.333%;">
                    <label>制单人:</label>
                    <span>
                        {{info.submitter}}
                    </span>
                </li>
                <li class="list-item" style="width: 36.333%;">
                    <label>打印日期:</label>
                    <span>{{new Date().getTime() | date('yyyy年MM月dd日 HH:mm:ss')}}</span>
                </li>
                <li class="list-item" style="width: 27.333%;">
                    <label>客户签字:</label>
                    <span></span>
                </li>
            </ul>
        </div>
        <div class="clearfix">
            <div class='fl f11 fbold' style="width: 72.666%;">   
            客户评价： 优&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;良&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;中&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;差
            </div>
        </div>
        
    </div>
  </base-print>
</template>
<script>
import BasePrint from "@c/print";
import Convert from "../../utils/number_convert";
import {mapGetters} from 'vuex';
export default {
    props:{
        info:Object
    },
    data () {
        return {
            numPerPage: 7,
            blankArr:[]
        }
    },
    computed: {
        ...mapGetters([
            'userInfo'     
        ]),
        printPages () {
            let tempArr = [];
            if (this.info.product !== undefined) {
                let tempPage = {};
                let tempLPXiaoji = 0;
                let tempTSXiaoji = 0;
                for (let len = this.info.product.length, i = 0; i < len; i++) {
                    if (i % this.numPerPage === 0) {
                        tempLPXiaoji = 0;
                        tempTSXiaoji = 0;
                        tempPage = {"products":[]}
                    }

                    tempTSXiaoji += parseFloat(this.info.product[i].tiesun_amount) || 0;
                    tempLPXiaoji += parseFloat(this.info.product[i].lipei_amount) || 0;
                    tempPage.products.push(this.info.product[i]);

                    if (i % this.numPerPage === this.numPerPage - 1 || i + 1 === len) {
                        tempPage.LPXiaoji = tempLPXiaoji.toFixed(2);
                        tempPage.TSXiaoji = tempTSXiaoji.toFixed(2);
                        tempPage.LPRevert = Convert.numberRevert(tempPage.LPXiaoji);
                        tempArr.push(tempPage);
                    }
                }
                this.blankArr = new Array(this.numPerPage - this.info.product.length % this.numPerPage);
                this.info.lipei_total_revert = Convert.numberRevert(this.info.lipei_total_amount);
            }
            return tempArr;
        }
    },
    components : {
        BasePrint
    },
    methods: {
        sbPrint (dom) {
            var LODOP = window.getCLodop();
            LODOP.PRINT_INIT("打印"); 
            LODOP.SET_PRINT_PAGESIZE(1,2410,1400,"");
            let prints = dom.getElementsByClassName("print");

            for (let len = prints.length, i = 0; i < len; i++) {
                if (i !== 0) {
                    LODOP.NewPage();
                }
                let aHtml = [];
                aHtml.push('<!DOCTYPE html>');
                aHtml.push('<html>');
                aHtml.push("<head><link href='/manage/static/sass/printori.css' type='text/css' rel='stylesheet'><meta http-equiv='X-UA-Compatible' content='IE=Edge,chrome=1' /></head><body>");
                aHtml.push(prints[i].outerHTML);
                aHtml.push("</body></html>");
                let strHtml = aHtml.join("");
                LODOP.ADD_PRINT_HTM(5,-145,1050,2970,strHtml);
            }

            LODOP.SET_PREVIEW_WINDOW(0,0,0,0,0,"");
            LODOP.PREVIEW();  
            // LODOP.PRINT_DESIGN();   
        }
    }
}
</script>
